<template>
  <v-card>
      <v-layout class="rewardbox">
        <v-flex class="reward-points-page">
          <h2>Reward Points</h2>
          </v-flex>
          <div class="reward-pointsdetail">
            <v-flex class="leftbox">
              <template>
                <v-card class="imagebox" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="points-text">MY POINTS</div>
                      <v-list-item-title class="points">
                        {{reward_points}}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <div class="reedem-btn">
                    <v-btn class="orange-btn btn" @click="rewarddialog = !rewarddialog"> REDEEM POINTS </v-btn>
                  </div>

                 <a href="javascript:void(0)" class="how-work" style="color: rgb(241, 151, 0);font-size: 14px;padding-right: 10px;cursor: pointer;display: block;text-align: right;padding-bottom:5px;text-decoration: none;" @click="dialog = !dialog">Terms & Conditions</a>
                </v-card>

              <div class="text-center">
                <v-dialog
                  v-model="dialog"
                  width="700"
                >
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Reward Points- Terms & Conditions
                    </v-card-title>
                    <v-card-text>
                     <ol style="margin-top:10px;">
                      <li>You can earn reward points on your subscription to Nimeya and on referring members</li>
                      <li>Referral is only applicable for new subscription upon payment of subscription fees.</li>
                      <li>You will get 49/99/149 reward points once you subscribe to Nimeya for Silver/Gold &amp; Platinum subscriptions respectively</li>
                      <li>For every successful reference you will earn 100 rewards points</li>
                      <li>Each reward point is equivalent to Indian Rupee one</li>
                      <li>Reward points can only be redeemed on Nimeya products and services</li>
                      <li> Reward points cannot be encashed</li>
                      <li>The Company has the right to change the rupee value of reward points at a future date</li>
                      <li>Change in rupee value of reward points will be intimated in advance</li>
                      <li>Reward points will be credited to your account after 15 days post realization of the full payment towards subscription</li>
                      <li>You can redeem your reward points against subsequent renewal fees and/or purchasing top-up services as and when offered</li>
                      <li>Unutilized reward points will be carried forward</li>
                      <li>Reward points are non-transferable</li>
                      <li>Balance reward points, if any, will lapse on discontinuance of the subscription of Nimeya</li>
                      <li>The terms and conditions can be changed by the Company from time to time.</li>
                      <li>The above terms &amp; conditions has to be read in conjunction with the Privacy Policy &amp; Terms of Use</li>
                    </ol>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <div class="text-center">
                <v-dialog
                  v-model="rewarddialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Reward Points
                    </v-card-title>
                    <v-card-text style="margin-top:10px;">
                      <span>You can redeem reward points to renew your subscription or to purchase any value-added services (if any). Please go through Reward Points terms and conditions.</span>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="rewarddialog = false"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>




              </template>
            </v-flex>

            <v-flex class="rightbox">
              <v-list subheader two-line class="reward-points">
                <h2>Points Earning History</h2>
                <v-list-item v-if="userList" v-for="rewardsPoint in userList" :key="rewardsPoint.title">
                  <span>
                    <strong>{{rewardsPoint.points}}</strong>
                    Points
                  </span>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="rewardsPoint.name"
                    ></v-list-item-title>

                    <v-list-item-subtitle v-if="user_name==rewardsPoint.name"
                    >Reward points from your subscription.</v-list-item-subtitle>
                    <v-list-item-subtitle v-else
                    >Got 100 reward points from {{rewardsPoint.name}}'s successful join the app.</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    
                      <p>{{rewardsPoint.registered_date}}</p>
        
                  </v-list-item-action>
                </v-list-item> 

              </v-list>
            </v-flex>
          </div>
      </v-layout>
  </v-card>
</template>

<script>
  import { GET_REFERRAL_DETAIL } from "../../store/actions.type";
  import { isEmpty } from 'lodash';
  import { Auth } from "aws-amplify";
  export default {
    data: () => ({
      reward_points:0,
      userList:'',
      dialog: false,
      rewarddialog:false,
      user_name:''
    }),
    computed: {  
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getReferralDetail.data);
      },
    },
    mounted(){
      Auth.currentAuthenticatedUser({
				bypassCache: false
			}).then(user => {	
				this.user_name = user.attributes["custom:name"];
			})
      this.getReferralDetail();
    },
    unmounted(){
      this.getReferralDetail();
    },
    methods:{
      getReferralDetail(){
          this.$store.dispatch(GET_REFERRAL_DETAIL, {
            data:{
              aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
            },
            api:'get-referral-detail',
          }).then(()=>{
            let response = this.$store.getters.getReferralDetail.data
            if (this.$store.getters.getReferralDetail.status == 'error') {
              return [];
            }else{
              this.userList = response.users;
              this.reward_points = response.reward_points;
              // this.updateReferralListData('commitReferralListData',response.users);
            }
          })
          .catch(function (error) {
          });
        }
        // else
        // {
        //   this.userList = this.ReferralListData;
        // }
      // }
    },
  }
</script>

